import { InjectionToken } from '@angular/core';

export interface HasUnsavedChanges {
  hasUnsavedChanges(): boolean;
}

export const UNSAVED_CHANGES_CHECKERS = new InjectionToken<HasUnsavedChanges[]>('UNSAVED_CHANGES_CHECKERS');
